import styled from 'styled-components';
import { bodyMedium } from '../paragraph';

export const Wrapper = styled.label<{ hide?: boolean }>`
  display: ${({ hide = false }): string => (hide === true ? 'none' : 'flex')};
  flex-direction: column;
`;

export const ErrorText = styled.div`
  ${bodyMedium}

  color: ${({ theme }): string => theme.palette_alert_50};
  margin-top: ${({ theme }): string => theme.spacing_unit_x1};
`;
